<template>
    <v-container fluid fill-height px-0 class="main-container container-fixed d-block">
        <div class="content-block">
            <v-flex class="d-flex justify-space-between align-center mx-6">
                <div class="arrow-btn d-inline-flex" @click="back">
                    <div
                        v-html="require('!html-loader!@/assets/icons/arrow_down_icon.svg')"
                        class="d-inline-flex rotate-90 size-28"
                    />
                </div>
                <div class="title-text d-inline-flex">
                    {{ deviceData.name }}
                </div>
                <div class="d-inline-flex" style="width: 28px"></div>
            </v-flex>
            <v-layout row v-if="deviceData" class="ma-0 px-6 mb-2 w-100 justify-center">
                <span class="main-text ml-1" v-if="deviceData.location">
                    ({{ deviceData.location }})
                </span>
            </v-layout>
            <v-layout column ma-0 class="main-text w-100 history-list scrollbar-block" v-if="motions.length > 0">
                <v-flex
                    xs12
                    v-for="(motion, index) in motions"
                    :key="index" class="history"
                    :class="{'history__high': motion.new_day}"
                >
                    <v-layout v-if="motion.new_day" class="history__title main-text">
                        {{motion.new_day}}
                    </v-layout>
                    <v-flex class="history-row">
                        <div class="history-row__time">
                            <div class="time-row main-text__medium">
                                начало: <span class="main-text">{{motion.start_updated}}</span>
                            </div>
                            <div class="time-row main-text__medium">
                                конец: <span class="main-text">{{motion.end_updated}}</span>
                            </div>
                            <div class="time-row main-text__medium">длительность: <span class="main-text">{{motion.text_duration}}</span></div>
                        </div>
                    </v-flex>
                </v-flex>
            </v-layout>
            <div class="d-flex align-center history-list__error" v-else>
                <v-flex class="d-block text-center">
                    <div>
                        <div v-html="require('!html-loader!@/assets/images/error.svg')" class="d-inline-flex mb-8" />
                        <div class="common-text text-center">
                            Нет истории
                        </div>
                    </div>
                </v-flex>
            </div>
            <ModalWaiting v-model="openModalWaiting"></ModalWaiting>
        </div>
    </v-container>
</template>

<script>
import ModalWaiting from "@/components/modals/ModalWaiting";
import {eventBus} from "@/main";
import {getTimeFromDate} from "@/utils";
import {timeWithTZ} from "@/utils";

export default {
    name: "MotionHistory",
    components: {
        ModalWaiting,
    },
    data() {
        return {
            deviceUID: null,
            deviceData: {},
            motions: [],
            openModalWaiting: false,
            month: ["января", "февраля", "марта", "апреля", "мая", "июня", "июля", "августа", "сентября", "октября", "ноября", "декабря"],
        };
    },
    created() {
        eventBus.$on("reconnect", this.loadPage);
    },
    beforeDestroy() {
        eventBus.$off("reconnect", this.loadPage);
    },
    mounted() {
        this.loadPage();
    },
    methods: {
        loadPage() {
            this.deviceUID = this.$route.params.id;
            if (this.deviceUID) {
                this.getMotions();
            }
        },
        getMotions() {
            this.motions = [];
            this.openModalWaiting = true;
            this.$http.get('/devices/home/motion-history/' + this.deviceUID + '/')
                .then((res) => {
                    this.deviceData = res.data.device;
                    this.motions = res.data.actions;
                    this.motions.forEach((motion, index) => {
                        motion.start_updated = this.getTime(motion.start);
                        motion.end_updated = this.getTime(motion.end);
                        motion.text_duration = this.formattedDuration(motion.duration);
                        if (index > 0) {
                            if (this.checkDay(motion.start) != this.checkDay(this.motions[index - 1].start)) {
                                motion.new_day = this.getDateTime(motion.start);
                            }
                        } else {
                            motion.new_day = this.getDateTime(motion.start);
                        }
                    });
                })
                .finally(() => {
                    this.openModalWaiting = false;
                });
        },
        getTime(time) {
            return getTimeFromDate(time);
        },
        checkDay(day) {
            return timeWithTZ(day).split('T')[0];
        },
        getDateTime(date_time) {
            let offsetDate = timeWithTZ(date_time).split('T')[0];
            let parsedDate = offsetDate.split('-');
            return parsedDate[2] + " " + this.month[parseInt(parsedDate[1]) - 1] + " " + parsedDate[0];
        },
        formattedDuration(val) {
            val = parseInt(val);
            if (val >= 60) {
                let minutes = Math.floor(val / 60);
                let seconds = val % 60;
                let hours = Math.floor(minutes / 60);
                minutes = minutes % 60;
                let row = "";
                if (hours) {
                    row = hours + " ч.";
                }
                if (minutes) {
                    if (hours) {
                        row += " " + minutes + " мин.";
                    }
                    else {
                        row += minutes + " мин.";
                    }
                }
                if (seconds) {
                    if (hours || minutes) {
                        row += " " + seconds + " сек.";
                    } else {
                        row += seconds + " сек.";
                    }
                }
                return row;
            }
            return val + " сек.";
        },
        back() {
            this.$router.push({ name: "homepage" });
        },
    },
}
</script>

<style lang="scss" scoped>
.rotate-90.v-image {
    transform: rotate(90deg);
}
</style>